"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_animated_popup_1 = __importDefault(require("react-animated-popup"));
var Popup = function (_a) {
    var visible = _a.visible, onClose = _a.onClose, children = _a.children, _b = _a.style, style = _b === void 0 ? {} : _b;
    var defaultStyle = __assign({ height: "45vh", width: "50vw", maxWidth: "50vw", display: "flex", flexDirection: "column" }, style);
    return (react_1.default.createElement(react_animated_popup_1.default, { visible: visible, onClose: onClose, style: defaultStyle }, children));
};
exports.default = Popup;
